var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearCrossedHalfLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.95257 3.55762C4.14436 4.36583 3.69031 5.46201 3.69031 6.605C3.69031 10.4837 7.99995 13.5004 7.99995 13.5004C7.99995 13.5004 9.62371 12.3638 10.8778 10.5889",
    stroke: "#103045",
    strokeWidth: 0.811227,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24078 7.80124C9.08358 7.96434 8.89579 8.09488 8.68813 8.18541C8.48048 8.27594 8.25702 8.32468 8.03053 8.32885C7.80404 8.33302 7.57895 8.29254 7.3681 8.20972C7.15725 8.1269 6.96478 8.00336 6.80168 7.84615C6.63857 7.68895 6.50803 7.50116 6.4175 7.2935C6.32698 7.08585 6.27824 6.8624 6.27407 6.6359C6.26989 6.40941 6.31038 6.18432 6.3932 5.97347C6.47602 5.76262 6.59956 5.57015 6.75676 5.40705",
    stroke: "#103045"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55151 2.07715L13.5515 13.0771",
    stroke: "#103045",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearCrossedHalfLocation);
export default __webpack_public_path__ + "static/media/clearCrossedHalfLocation.8bdd9353f7ba9a7c6754eaf019ca6655.svg";
export { ForwardRef as ReactComponent };